import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';

import { useContext } from 'react'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Card, CircularProgress, Divider, FormControl, Grid2, IconButton, InputAdornment, InputLabel, List, ListItem, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { AuthContext } from '../../utils/AuthContext';
import { registerAgent } from '../../services/AuthService';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import { resetPassword, updateAgent } from '../../services/UsersService';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import formatMoney from '../../utils/formatMoney';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import moment from 'moment';


const InfoField = ({ label, value }) => {
  return (
    <div>
      <Typography sx={{ fontSize: 12, color: '#616161' }}>{label}</Typography>
      {/* <Card variant="outlined" sx={{ p: 1, mt: 0.4, fontSize: 18 }}>
        {value}
      </Card> */}
      <TextField
        value={value}
        sx={{ mt: 0.5 }}
        size="small"
        fullWidth
      />
    </div>
  );
};

function ClientInformationDialog({ dialogOpen, setDialogOpen, callback, selectedClient }) {
  const { auth } = useContext(AuthContext);

  const [isLoading, setLoading] = useState(false);

  const dialogRef = useRef();

  const [expanded, setExpanded] = useState('panel-individual');

  useEffect(() => {
    setInitialExpanded();
  }, [selectedClient]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };



  const handleClose = () => {
    setDialogOpen(false);
  };

  const getFirstReferredIndividual = (client) => {
    if (!client) return;

    const parsedData = JSON.parse(client.referred_individual);
    const individuals = parsedData.map((item) => item.individual);
    if (individuals.length > 0) {
      return individuals[0];
    }
  };

  const getFirstReferredGroup = (client) => {
    if (!client) return;

    const parsedData = JSON.parse(client.referred_group);
    const groups = parsedData.map((item) => item.group);
    if (groups.length > 0) {
      return groups[0];
    }
  };

  function getReferredIndividuals(client) {
    if (!client) return [];

    const parsedData = JSON.parse(client.referred_individual);
    const individuals = parsedData.map((item) => item.individual);


    return individuals;
  };

  function getReferredGroups(client) {
    if (!client) return [];

    const parsedData = JSON.parse(client.referred_group);
    const groups = parsedData.map((item) => item.group);

    return groups;
  };

  function setInitialExpanded() {
    if (getReferredIndividuals(selectedClient).length > 0) {
      setExpanded('panel-individual');
    } else if (getReferredGroups(selectedClient).length > 0) {
      setExpanded('panel-group');
    }
  }



  return (
    <Dialog
      open={dialogOpen}
      onClose={handleClose}
      sx={{ zIndex: 9998 }}
      ref={dialogRef}
    >
      <DialogTitle sx={{ mt: 3 }}>
        Client Information
      </DialogTitle>


      <DialogContent sx={{ width: {
        md: 400
      } }}>
        <Box sx={{ mt: 1 }}>
          <InfoField label="CLIENT" value={getFirstReferredIndividual(selectedClient) || getFirstReferredGroup(selectedClient) || ''} />
        </Box>

        {/* <Box sx={{ mt: 1 }}>
          <Accordion expanded={expanded === 'panel-individual'} onChange={handleChange('panel-individual')} variant="outlined" sx={{ border: 'none' }}>
            <AccordionSummary sx={{ padding: 0, margin: 0 }} expandIcon={<ExpandMoreOutlinedIcon />}>INDIVIDUAL CLIENTS</AccordionSummary>
            <AccordionDetails>
              <List>
                {
                  getReferredIndividuals(selectedClient).map(individual => {
                    return <>
                      <ListItem key={individual}>{individual}</ListItem>
                    </>
                  })
                }
              </List>
            </AccordionDetails>
          </Accordion>
        </Box>

        <Box sx={{ mb: 1 }}>
          <Accordion expanded={expanded === 'panel-group'} onChange={handleChange('panel-group')} variant="outlined" sx={{ border: 'none' }}>
            <AccordionSummary sx={{ padding: 0, margin: 0 }} expandIcon={<ExpandMoreOutlinedIcon />}>GROUP CLIENTS</AccordionSummary>
            <AccordionDetails>
              <List dense>
                {
                  getReferredGroups(selectedClient).map(group => {
                    return <>
                      <ListItem>{group}</ListItem>
                    </>
                  })
                }
              </List>
            </AccordionDetails>
          </Accordion>
        </Box> */}
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 12, color: '#616161' }}>COMMISSION DATE</Typography>
          <OutlinedInput
            sx={{ mt: 0.5 }}
            size="small"
            fullWidth
            value={moment(selectedClient?.date, 'YYYY-MM-DD').format('MM/DD/YYYY')}
            startAdornment={
              <InputAdornment position="start">
                <EventOutlinedIcon />
              </InputAdornment>

            } />
        </Box>
        <Box sx={{ mt: 1 }}>
          <InfoField label="CS NO." value={selectedClient?.cs_no} />
        </Box>
        <Box sx={{ mt: 1 }}>
          <InfoField label="TYPE" value={selectedClient?.commission_type} />
        </Box>
        <Box sx={{ mt: 1 }}>
          <InfoField label="INSURER" value={selectedClient?.insurer} />
        </Box>
        <Box sx={{ mt: 1 }}>
          <InfoField label="TOTAL PREMIUM PAID" value={selectedClient?.currency + ' ' + formatMoney(selectedClient?.total_premium)} />
        </Box>
        <Box sx={{ mt: 1 }}>
          <InfoField label="COMMISSION PERCENTAGE" value={selectedClient?.commission_percentage + '%'} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ mb: 3, px: 2 }}>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>

    </Dialog>
  )
}

export default ClientInformationDialog

